import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '../../../../../app/store/utils/baseQueryWithReauth';
import {
  SYSTEM_BILLING_BASE,
  unwrapApiData,
} from '../../../shared/infrastructure/api/unwrapApiData';
import type {
  SubscriptionDetailDto,
  SubscriptionsListParams,
  SubscriptionsListResponse,
  SubscriptionStatsDto,
} from '../../domain/subscription.types';

export const billingSubscriptionsApi = createApi({
  reducerPath: 'billingSubscriptionsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SubscriptionStats', 'SubscriptionList', 'SubscriptionDetail'],
  endpoints: build => ({
    getSubscriptionStats: build.query<SubscriptionStatsDto, void>({
      query: () => ({
        url: `${SYSTEM_BILLING_BASE}/subscriptions/stats`,
        method: 'GET',
      }),
      transformResponse: (response: unknown) =>
        unwrapApiData<SubscriptionStatsDto>(response),
      providesTags: ['SubscriptionStats'],
    }),

    getSubscriptionsList: build.query<SubscriptionsListResponse, SubscriptionsListParams>({
      query: params => ({
        url: `${SYSTEM_BILLING_BASE}/subscriptions/list`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: unknown) =>
        unwrapApiData<SubscriptionsListResponse>(response),
      providesTags: ['SubscriptionList'],
    }),

    getSubscriptionById: build.query<SubscriptionDetailDto, number>({
      query: subscriptionId => ({
        url: `${SYSTEM_BILLING_BASE}/subscriptions/${subscriptionId}`,
        method: 'GET',
      }),
      transformResponse: (response: unknown) =>
        unwrapApiData<SubscriptionDetailDto>(response),
      providesTags: (_result, _error, subscriptionId) => [
        { type: 'SubscriptionDetail', id: subscriptionId },
      ],
    }),
  }),
});

export const {
  useGetSubscriptionStatsQuery,
  useGetSubscriptionsListQuery,
  useGetSubscriptionByIdQuery,
} = billingSubscriptionsApi;
